(function () {
  'use strict';
  var dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  var formatters = {};
  function partsAt(date, zone) {
    if (!formatters[zone]) formatters[zone] = new Intl.DateTimeFormat('en-US', {
      timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    var parts = {};
    formatters[zone].formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    return parts;
  }
  function wallTime(date, hours, minutes, seconds, zone) {
    var target = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), hours, minutes, seconds);
    var instant = target;
    for (var i = 0; i < 3; i++) {
      var parts = partsAt(new Date(instant), zone);
      var observed = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      instant += target - observed;
    }
    return new Date(instant);
  }
  function calculate(now, settings) {
    var zone = settings.timeZone || 'America/Chicago';
    var parts = partsAt(now, zone);
    var processingDay = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    var cutoffParts = (settings.cutoff || '15:00:00').split(':').map(Number);
    var minimum = Number(settings.minimum), maximum = Number(settings.maximum);
    var offDays = (settings.offDays || '').toUpperCase().split(/\s+/);
    if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || minimum < 0 || maximum < minimum || maximum > 365) return null;
    if (dayNames.every(function (day) { return offDays.indexOf(day) !== -1; })) return null;
    if (cutoffParts.length !== 3 || cutoffParts.some(function (value) { return !Number.isInteger(value) || value < 0; }) || cutoffParts[0] > 23 || cutoffParts[1] > 59 || cutoffParts[2] > 59) return null;
    function cutoff(day) { return wallTime(day, cutoffParts[0], cutoffParts[1], cutoffParts[2], zone); }
    function isOff(day) { return offDays.indexOf(dayNames[day.getUTCDay()]) !== -1; }
    if (now >= cutoff(processingDay)) processingDay.setUTCDate(processingDay.getUTCDate() + 1);
    while (isOff(processingDay)) processingDay.setUTCDate(processingDay.getUTCDate() + 1);
    function deliveryDay(days) {
      var day = new Date(processingDay);
      // Preserve the theme's convention: the processing day is day one.
      for (var remaining = Math.max(0, days - 1); remaining > 0;) {
        day.setUTCDate(day.getUTCDate() + 1);
        if (!isOff(day)) remaining--;
      }
      return day;
    }
    return { start: deliveryDay(minimum), end: deliveryDay(maximum), minutes: Math.max(1, Math.ceil((cutoff(processingDay) - now) / 60000)) };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { calculate: calculate }; return; }
  if (window.textualDeliveryEstimateLoaded) return;
  window.textualDeliveryEstimateLoaded = true;
  function update() {
    document.querySelectorAll('.js-product-delivery-estimate[data-delivery-time-zone]').forEach(function (element) {
      var result = calculate(new Date(), {
        timeZone: element.dataset.deliveryTimeZone,
        cutoff: element.dataset.deliveryCutOffTime,
        minimum: element.dataset.minDeliveryDays,
        maximum: element.dataset.maxDeliveryDays,
        offDays: element.dataset.deliveryOffDays
      });
      if (!result) return;
      var translations = window.store && window.store.translations || {};
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var days = element.dataset.deliveryDays.split(' ');
      function display(date) {
        var month = months[date.getUTCMonth()];
        return days[date.getUTCDay()] + ' ' + (translations['month' + month] || month) + ' ' + String(date.getUTCDate()).padStart(2, '0');
      }
      var start = element.querySelector('.js-product-delivery-estimate-start-date');
      var end = element.querySelector('.js-product-delivery-estimate-end-date');
      var time = element.querySelector('.js-product-delivery-estimate-time');
      if (start) start.textContent = display(result.start);
      if (end) end.textContent = display(result.end);
      if (time) {
        var hours = Math.floor(result.minutes / 60);
        var minutes = result.minutes % 60;
        var countdown = [];
        if (hours) countdown.push(hours + (hours === 1 ? ' hour' : ' hours'));
        if (minutes || !hours) countdown.push(minutes + (minutes === 1 ? ' minute' : ' minutes'));
        time.textContent = countdown.join(' ');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setInterval(update, 1000);
  document.addEventListener('shopify:section:load', update);
})();
